import { requests } from "../../../utils/api/api.service";
import { WEB_STATISTICS_URL } from "../../../utils/api/endpoints";
import { IStatistics } from "../../../shared/interfaces/statistics/IStatistics";

export const WebStatisticsService = {
  get: (): Promise<{ data: IStatistics }> => requests.get(WEB_STATISTICS_URL),
};
